<template>
  <layout>
    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">注册用户</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">注册数量</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">人</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Input size="small" v-model="searchMap.keyword" placeholder="注册用户" style="width: 250px" />
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
        


        
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      pageThis: this,
      loading: false,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "序号",
          key: "id",
          width: 120,
          align: "center",
        },
        {
          title: "注册用户",
          key: "name",
          minWidth: 120,
        
        },
        {
          title: "注册地址",
          key: "addressFull",
          width: 120,
          align: "center",
        },
        
      
        {
          title: "创建时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
       
       
      ]),
      searchMap: {
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      total: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    var year = this.$getUrlParams("year");
    this.searchMap.daterange = this.$yeaerStartEnd(year);
    this.getList();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var parameter = this.searchMap;
      var https = {
        type: "isPagelist",
        api: this.$api.getUserList,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.total = res.count;
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
<style>
.pageSearch {
  width: 100% !important;
  left: 0;
}
.pageContent {
  width: 100% !important;
  left: 0;
}
.QHPage {
  left: 0;
}
</style>
